import { FormField } from "@faire/retailer-visitor-shared/components/SignUpForm/FormField";
import { useRefFrom } from "@faire/web--source/ui/hooks/useRefFrom";
var EVENT_NAME = "store-opening-date";
var EVENT_PREFIX = "sign-up-page/modal";
// Started this state here, but if there are no other usages I'll put it back
// inside useAppSignUpState.
export var useStoreOpeningDateState = function() {
    var storeOpeningDate = useRefFrom(function() {
        return new FormField(undefined, EVENT_NAME, function() {
            return false;
        }, EVENT_PREFIX);
    }).current;
    return {
        storeOpeningDate: storeOpeningDate
    };
};
